const UUIDGenerator = null;
export default UUIDGenerator;
